let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9uQpw")).then(() => parcelRequire('7z7s1'));